import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { BillingNav } from './BillingNav';
import { billingApi, euro } from '@/services/billingApi';
import { toast } from 'sonner';

export default function BillingAgingPage() {
  const [data, setData] = useState<any>(null);
  useEffect(() => {
    billingApi.aging().then(setData).catch((e) => toast.error(e.response?.data?.message || 'Errore'));
  }, []);
  if (!data) return <div>Caricamento...</div>;
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold">Scadenziario</h1>
      <BillingNav />
      <Card className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b text-left text-gray-500">
              <th className="p-3">Fattura</th>
              <th className="p-3">Cliente</th>
              <th className="p-3">Scadenza</th>
              <th className="p-3 text-right">Residuo</th>
            </tr>
          </thead>
          <tbody>
            {data.invoices.length === 0 && (
              <tr>
                <td className="p-6 text-gray-500" colSpan={4}>
                  Nessuna fattura aperta
                </td>
              </tr>
            )}
            {data.invoices.map((row: any) => (
              <tr key={row.id} className={row.overdue ? 'bg-red-50' : ''}>
                <td className="p-3">
                  <Link className="text-blue-600" to={`/preventivi-e-conti/${row.id}`}>
                    {row.numberDisplay}
                  </Link>
                </td>
                <td className="p-3">
                  <Link className="text-blue-600" to={`/clients/${row.clientId}`}>
                    {row.clientName}
                  </Link>
                </td>
                <td className="p-3">{row.dueDate ? new Date(row.dueDate).toLocaleDateString('it-IT') : '—'}</td>
                <td className="p-3 text-right font-medium">{euro(row.remainder)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
      <h2 className="text-lg font-semibold">Preventivi in scadenza</h2>
      <Card className="overflow-x-auto">
        <table className="w-full text-sm">
          <tbody>
            {data.quotes.length === 0 && (
              <tr>
                <td className="p-6 text-gray-500">Nessun preventivo in scadenza</td>
              </tr>
            )}
            {data.quotes.map((row: any) => (
              <tr key={row.id} className={row.overdue ? 'bg-amber-50' : ''}>
                <td className="p-3">
                  <Link className="text-blue-600" to={`/preventivi-e-conti/${row.id}`}>
                    {row.numberDisplay}
                  </Link>
                </td>
                <td className="p-3">
                  <Link className="text-blue-600" to={`/clients/${row.clientId}`}>
                    {row.clientName}
                  </Link>
                </td>
                <td className="p-3">{row.validUntil ? new Date(row.validUntil).toLocaleDateString('it-IT') : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
